const OrderType = {
  SET_ORDER_LIST: "SET_ORDER_LIST",
  SET_ORDER_DETAILS: "SET_ORDER_DETAILS",
  SET_USER_ORDER_LIST: "SET_USER_ORDER_LIST",
  CANCEL_ORDER: "CANCEL_ORDER",
  DELIVERY_ORDER_STATUS: "DELIVERY_ORDER_STATUS",
  ORDER_ACCEPTANCE: "ORDER_ACCEPTANCE",
  SET_ORDER_INVOICE: "SET_ORDER_INVOICE",
  SET_PO_ORDER: "SET_PO_ORDER",
  GET_RECENT_ORDERS: "GET_RECENT_ORDERS",
  MY_ORDER_RECEIVED: "MY_ORDER_RECEIVED",
  SET_BUYER_INVOICE: "SET_BUYER_INVOICE",
};

export interface GetOrder {
  limit: number;
  search: any;
  page: number;
  myOrderStatus: string;
}

export interface GetOrderDetails {
  orderId: any;
}

export interface GetUserOrder {
  limit: number;
  search: any;
  page: number;
  orderStatus: string;
}

export interface CancelOrder {
  id: number;
  reason: string;
}

export interface UpdateOrderStatus {
  id: number;
  status: string;
}

export interface OrderAcceptance {
  id: number;
  status: number;
}

export interface GetOrderInvoice {
  id: any;
}

export interface GetPOOrder {
  limit: number;
  search: any;
  page: number;
}

export interface orderReceived {
  id: number;
}

export interface GetBuyerInvoice {
  id: any;
}

export default OrderType;
